/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './self-registration.scss';

/*@ngInject*/
export default function selfRegistrationController($scope, $rootScope, selfRegistrationService, $translate, toast, types) {// eslint-disable-line

    var vm = this;

    vm.types = types;

    vm.selfRegistrationParams = {};

    initSelfRegistration();

    function initSelfRegistration() {
        selfRegistrationService.getSelfRegistrationParams().then(function (settings) {
            if (settings) {
                vm.selfRegistrationParams = settings;
                if (vm.selfRegistrationParams.domainName !== null) {
                    vm.registerLink = selfRegistrationService.getRegistrationLink(settings.domainName);
                }
                if (vm.selfRegistrationParams.signUpTextMessage !== null) {
                    vm.selfRegistrationParams.signUpTextMessage = convertHTMLToText(vm.selfRegistrationParams.signUpTextMessage);
                }
                vm.selfRegistrationForm.$setPristine();
            }
        });

        vm.tinyMceOptions = {
            plugins: ['textcolor colorpicker link table image imagetools code fullscreen'],
            menubar: "edit insert tools view format table",
            toolbar: 'fontselect fontsizeselect | formatselect | bold italic  strikethrough  forecolor backcolor | link | table | image | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code | fullscreen',
            font_formats: 'Helvetica Neue="Helvetica Neue",helvetica,arial,sans-serif;Helvetica=helvetica,arial,sans-serif;Times New Roman=times new roman,times,serif;Sans Serif=sans-serif,helvetica,arial;Arial=arial,helvetica,sans-serif;Courier New=courier new,courier,monospace;',
            fontsize_formats: '8pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
            height: 280,
            autofocus: false,
            branding: false
        };
    }

    vm.save = save;
    vm.onActivationLinkCopied = onActivationLinkCopied;

    function onActivationLinkCopied(){
        toast.showSuccess($translate.instant('user.activation-link-copied-message'), 750, angular.element('#registration-link-content'), 'top left');
    }

    function save() {
        var saveObject = {};
        saveObject = angular.copy(vm.selfRegistrationParams);
        if (saveObject.signUpTextMessage !== "" && saveObject.signUpTextMessage !== null) {
            saveObject.signUpTextMessage = convertTextToHTML(saveObject.signUpTextMessage);
        }

        selfRegistrationService.saveSelfRegistrationParams(saveObject).then(function () {
            if (saveObject.domainName !== "") {
                vm.registerLink = selfRegistrationService.getRegistrationLink(saveObject.domainName);
            }
            vm.selfRegistrationForm.$setPristine();
        });
    }

    function convertTextToHTML(str){
        return str.replace(/\n/g, '<br/>');
    }

    function convertHTMLToText(str){
        return str.replace(/<br\s*[/]?>/gi, "\n");
    }
}